import { render, staticRenderFns } from "./FriendlyUrl.vue?vue&type=template&id=74543995&"
import script from "./FriendlyUrl.vue?vue&type=script&lang=js&"
export * from "./FriendlyUrl.vue?vue&type=script&lang=js&"
import style0 from "./FriendlyUrl.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports